import * as trace from 'owa-trace';
import { default as loadWebPushOptions } from './services/loadWebPushOptions';
import { requestExtensionForPushSubscription } from 'extension-communication/lib/handlers/requestExtensionForPushSubscription';

export default async function bootstrapWebPushService(windowObj: Window) {
    //this call fails when run on local owa web server localhost:5001
    const webPushNotificationsOptions = await loadWebPushOptions();
    // tslint:disable-next-line:no-console
    console.log('webPushNotificationsOptions: ', webPushNotificationsOptions);
    if (webPushNotificationsOptions == null) {
        trace.trace.warn('[WebPush] WebPushNotificationsOptions not loaded.');
        return;
    }

    try {
        // tslint:disable-next-line:no-console
        console.log('webPushNotificationsOptions.enabled: ', webPushNotificationsOptions.enabled);
        requestExtensionForPushSubscription(webPushNotificationsOptions.applicationServerKey);
    } catch (error) {
        trace.errorThatWillCauseAlert(
            '[WebPush] Failed to initialize web push notifications, error: ' + error
        );
    }
}
